export const isSameDate = (d1, d2) => {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
};

export const arrayToSentence = (
  array,
  punctuation = '.',
  conjunction = 'and'
) => {
  if (array.length === 0) {
    return '';
  }

  if (array.length === 1) {
    return array[0] + punctuation;
  }

  const last = array[array.length - 1];

  let list = array.slice(0, -1).join(', ');
  if (array.length > 2) {
    list = `${list},`;
  }

  return `${list} ${conjunction} ${last}${punctuation}`;
};

export const formatPhone = phone => {
  if (!phone) {
    return '';
  }

  phone = phone.replace(/\D/g, '');

  return [phone.slice(0, 3), phone.slice(3, 6), phone.slice(6)]
    .filter(chunk => !!chunk)
    .join('-');
};

export const normalizeName = string => {
  //remove non-alphanumeric characters then remove spaces
  return string
    ? string
        .replace(/[^\w\s]|_/g, '')
        .replace(/\s{1,}/g, '')
        .toLowerCase()
    : '';
};

export const makeCancelable = promise => {
  let hasCanceled = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(
      val => (hasCanceled ? reject({ isCanceled: true }) : resolve(val)),
      error => (hasCanceled ? reject({ isCanceled: true }) : reject(error))
    );
  });

  return {
    promise: wrappedPromise,
    cancel: function() {
      hasCanceled = true;
    },
  };
};

export const sameAddresses = (a1, a2) => {
  return (
    a1.first_name === a2.first_name &&
    a1.last_name === a2.last_name &&
    a1.address1 === a2.address1 &&
    a1.address2 === a2.address2 &&
    a1.city === a2.city &&
    a1.state === a2.state &&
    a1.zipcode === a2.zipcode
  );
};

export const doesUserHaveRole = role => {
  return !!(global.gon.user && global.gon.user.roles.indexOf(role) >= 0);
};



// WEBPACK FOOTER //
// ./app/javascript/apps/account/utils.js